@if (photoReport) {
  <a class="photo-report no-drag" [routerLink]="!utils.isDesktop ? reportPageUrl : null">
    <div class="photo-report__image">
      <img src="/assets/images/icons-svg/photo-report-logo.svg" alt="photo-report-logo" />
    </div>
    <div class="photo-report__description">
      <a [routerLink]="utils.isDesktop ? reportPageUrl : null" class="nav-link">
        @if (photoReport.shop) {
          <app-text
            class="photo-report__description-name"
            [textSize]="TextSizes.h4Name"
            [textType]="TextType.base"
            [initialCase]="true"
            [text]="photoReport.shop.name + ', ' + photoReport.shop.city.name"
          ></app-text>
        }
      </a>
      <app-text
        [textSize]="TextSizes.mobBody"
        [textType]="TextType.base"
        class="grey text text_desktop"
        [text]="
          [
            photoReport.created | dateFormat,
            photoReport.imageCount | wordDeclension: imgDeclension,
          ].join(' · ')
        "
      ></app-text>
      <app-text
        [textSize]="TextSizes.mobPost"
        [textType]="TextType.base"
        class="grey text text_mob"
        [text]="
          [
            photoReport.created | dateFormat,
            photoReport.imageCount | wordDeclension: imgDeclension,
          ].join(' · ')
        "
      ></app-text>
    </div>
  </a>
}
